import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import moment from 'moment'

import { selectContractorByUuid } from '../payroll.selectors'
import {
  fetchContractorPayments,
  fetchSingleContractor,
} from '../payrollActions'
import { getContractorName } from '../helpers'
import { ContractorDetailsTab } from './ContractorDetailsTab'
import { ContractorPaymentsTab } from './ContractorPaymentsTab'
import { Tab, Text, Card, Icon, CardColors, Loader, Breadcrumb } from '@/ui'
import { ContractorDocumentsTab } from './ContractorDocumentsTab'
import { useReselector } from '@/utils/sharedHooks'
import { OnboardingCTA } from '../employee/OnboardingCTA'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import { useAppDispatch } from '@/utils/typeHelpers'
import { Gusto_ContractorPayment } from '../generated_gusto_types'
import { TypographyStyles } from '@/styles'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
export const PayrollContractor = () => {
  const dispatch = useAppDispatch()
  const { uuid } = useParams()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const contractor = useReselector(selectContractorByUuid, uuid)
  const [contractorPayments, setContractorPayments] = useState<
    Gusto_ContractorPayment[]
  >([])
  const [activeIndex, setActiveIndex] = useState(
    searchParams.get('tab') === 'documents' ? 2 : 0
  )

  // const panes = useMemo(
  //   () => [
  //     {
  //       menuItem: 'Details',
  //       render: () => (
  //         <Tab.Pane attached={false}>
  //           {contractor && (
  //             <ContractorDetailsTab
  //               contractor={contractor}
  //               payments={contractorPayments}
  //               goToPayments={() => setActiveIndex(1)}
  //             />
  //           )}
  //         </Tab.Pane>
  //       ),
  //     },
  //     {
  //       menuItem: 'Payments',
  //       render: () => (
  //         <Tab.Pane attached={false}>
  //           {contractor && (
  //             <ContractorPaymentsTab
  //               contractor={contractor}
  //               contractorPayments={contractorPayments}
  //             />
  //           )}
  //         </Tab.Pane>
  //       ),
  //     },
  //     {
  //       menuItem: 'Documents',
  //       render: () =>
  //         uuid ? (
  //           <Tab.Pane attached={false}>
  //             <ContractorDocumentsTab uuid={uuid} />
  //           </Tab.Pane>
  //         ) : null,
  //     },
  //   ],
  //   [contractor, contractorPayments, uuid]
  // )

  const panes = useMemo(
    () => [
      {
        menuItem: 'Details',
        render: () =>
          contractor ? (
            <ContractorDetailsTab
              contractor={contractor}
              payments={contractorPayments}
              goToPayments={() => setActiveIndex(1)}
            />
          ) : null,
      },
      {
        menuItem: 'Payments',
        render: () =>
          contractor ? (
            <ContractorPaymentsTab
              contractor={contractor}
              contractorPayments={contractorPayments}
            />
          ) : null,
      },
      {
        menuItem: 'Documents',
        render: () => (uuid ? <ContractorDocumentsTab uuid={uuid} /> : null),
      },
    ],
    [contractor, contractorPayments, uuid]
  )

  useEffect(() => {
    const fetchPayments = async () => {
      const res = await fetchContractorPayments({
        start_date: '2020-01-01',
        end_date: moment().add(1, 'month').format(DATE_FORMATS.GUSTO_SUBMIT),
        contractor_uuid: uuid,
      })(dispatch)
      if (res) {
        const overallPayments = res.contractor_payments.find(
          (payment) => payment.contractor_uuid === uuid
        )
        if (overallPayments) {
          setContractorPayments(overallPayments.payments)
        }
      }
    }

    if (!uuid) {
      return
    }

    dispatch(fetchSingleContractor(uuid))
    fetchPayments()
  }, [dispatch, uuid])

  return (
    <div id="payroll-employees" className="p-4">
      <Card color={CardColors.LEVEL_1}>
        {!contractor && <Loader />}
        {contractor && (
          <div className="space-y-6">
            <Breadcrumb>
              <Breadcrumb.List>
                <Breadcrumb.Item>
                  <Breadcrumb.Link
                    onClick={() => {
                      navigate('/payroll/employees')
                    }}
                  >
                    <Icon icon={faArrowLeft} />
                    Back to team
                  </Breadcrumb.Link>
                </Breadcrumb.Item>
              </Breadcrumb.List>
            </Breadcrumb>

            <Text variant={TypographyStyles.H1} className="w-full my-4">
              {getContractorName(contractor)}
            </Text>
            <OnboardingCTA
              teamMemberUuid={contractor.uuid}
              isEmployee={false}
            />

            <Tab
              panes={panes}
              onTabClick={(index) => setActiveIndex(index)}
              defaultActiveIndex={activeIndex}
            />
          </div>
        )}
      </Card>
    </div>
  )
}
